<div class="modal-container">
  <div class="modal-header no-print">
    <h2 mat-dialog-title>
      <mat-icon>cake</mat-icon>
      <span>Listar Aniversariantes</span>
    </h2>
    <button mat-icon-button (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- LOADING STATE -->
  @if (isLoading) {
  <div class="loading-container no-print">
    <app-loading-box width="100%" height="300px"></app-loading-box>
  </div>
  }

  <!-- STEP: FILTRO -->
  @if (step === 'filtro' && !isLoading) {
  <div class="content-body no-print">
    <form [formGroup]="formAniversariante" class="filter-form">
      <p class="mb-3">Selecione o período do aniversário:</p>
      <div class="row">
        <div class="col-6">
          <p class="text-muted mb-1 small">De:</p>
          <div class="d-flex gap-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Mês</mat-label>
              <mat-select formControlName="mesInicio">
                @for (mes of months; track mes) {
                <mat-option [value]="mes.value">{{ mes.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Dia</mat-label>
              <mat-select formControlName="diaInicio">
                @for (dia of daysStart; track dia) {
                <mat-option [value]="dia">{{ dia }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-6">
          <p class="text-muted mb-1 small">Até:</p>
          <div class="d-flex gap-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Mês</mat-label>
              <mat-select formControlName="mesFim">
                @for (mes of months; track mes) {
                <mat-option [value]="mes.value">{{ mes.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Dia</mat-label>
              <mat-select formControlName="diaFim">
                @for (dia of daysEnd; track dia) {
                <mat-option [value]="dia">{{ dia }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>
  }

  <!-- STEP: RELATORIO -->
  <div [hidden]="step !== 'relatorio' || isLoading" class="content-body modal-print-container">
    @if (step === 'relatorio') {
    <h3 class="mb-3" style="text-align: center; text-transform: uppercase; font-size: 1.1rem; color: #b73232">
      Relatório de Aniversariantes
    </h3>
    }

    @if (relatorioSimples.length > 0) {
    <div class="table-responsive">
      <table mat-table [dataSource]="relatorioSimples">
        <!-- Nome Column -->
        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef>Nome</th>
          <td mat-cell *matCellDef="let element">{{ element.nome }}</td>
        </ng-container>
        <!-- Cidade Column -->
        <ng-container matColumnDef="cidade">
          <th mat-header-cell *matHeaderCellDef>Município</th>
          <td mat-cell *matCellDef="let element">
            {{ element.cidade }}
            @if (element.uf) {
            <span> - {{ element.uf }}</span>
            }
          </td>
        </ng-container>
        <!-- Contato Column -->
        <ng-container matColumnDef="contato">
          <th mat-header-cell *matHeaderCellDef>Telefone / Celular</th>
          <td mat-cell *matCellDef="let element">
            @if (element.telefone) {
            <div>{{ element.telefone | foneMask }}</div>
            }
            @if (element.celular && element.celular !== element.telefone) {
            <div>{{ element.celular | foneMask }}</div>
            }
          </td>
        </ng-container>
        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>E-mail</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>
        <!-- Nascimento Column -->
        <ng-container matColumnDef="nascimento">
          <th mat-header-cell *matHeaderCellDef>Data Nasc.</th>
          <td mat-cell *matCellDef="let element">{{ element.dataFormatada }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    }

    <!-- EMPTY STATE -->
    @if (!isLoading && relatorioSimples.length === 0) {
    <div class="text-center p-4">
      <p>Nenhum registro encontrado para os filtros selecionados.</p>
    </div>
    }
  </div>

  <!-- FOOTER ACTIONS -->
  <div class="modal-footer no-print">
    <button mat-stroked-button class="btn-secondary" (click)="step === 'relatorio' ? voltar() : fechar()">
      {{ step === 'relatorio' ? 'Voltar' : 'Cancelar' }}
    </button>

    @if (step === 'filtro') {
    <button mat-flat-button class="btn-primary" (click)="submitAniversariante()">Gerar Lista</button>
    }

    @if (step === 'relatorio' && !isLoading && relatorioSimples.length > 0) {
    <button mat-flat-button class="btn-primary" (click)="imprimir()">
      <mat-icon>print</mat-icon> Imprimir
    </button>
    }
  </div>
</div>